if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      const serumSection = this.closest('#shopify-section-template--26261731180831__main');
      if (serumSection && this.mql.matches) {
        const mainSlider = this.querySelector('[id^="Slider-Gallery"]');
        const thumbSlider = this.elements.thumbnails.slider || this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        if (mainSlider && thumbSlider) {
          const mainHeight = Math.round(mainSlider.getBoundingClientRect().height || 0);
          if (mainHeight > 0) this.style.setProperty('--bloom-serum-main-height', `${mainHeight}px`);
          const itemTop = thumbnail.offsetTop;
          const itemBottom = itemTop + thumbnail.offsetHeight;
          const viewTop = thumbSlider.scrollTop;
          const viewBottom = viewTop + thumbSlider.clientHeight;
          const padding = 5;
          if (itemTop < viewTop + padding) {
            thumbSlider.scrollTo({ top: Math.max(0, itemTop - padding), behavior: 'smooth' });
          } else if (itemBottom > viewBottom - padding) {
            thumbSlider.scrollTo({ top: itemBottom - thumbSlider.clientHeight + padding, behavior: 'smooth' });
          }
        }
        return;
      }

      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* Bloom cosmetic-band mobile gallery arrow fallback v1 — exact section only */
(()=>{function init(){const root=document.querySelector('#shopify-section-template--26281102868767__main');if(!root||root.dataset.bloomGalleryArrowFixGlobalV1)return;root.dataset.bloomGalleryArrowFixGlobalV1='1';const list=root.querySelector('.product__media-list');if(!list)return;function slides(){return [...list.querySelectorAll('.product__media-item')].filter(el=>el.getBoundingClientRect().width>50)}function thumbs(){return [...root.querySelectorAll('.thumbnail-list .thumbnail')]}function width(){return list.clientWidth||slides()[0]?.getBoundingClientRect().width||360}function index(){const w=width();return Math.max(0,Math.min(slides().length-1,Math.round(list.scrollLeft/w)))}function setActive(i){slides().forEach((s,n)=>s.classList.toggle('is-active',n===i));thumbs().forEach((t,n)=>t.setAttribute('aria-current',n===i?'true':'false'))}function go(delta){const items=slides();if(!items.length)return;const next=Math.max(0,Math.min(items.length-1,index()+delta));list.scrollTo({left:next*width(),behavior:'smooth'});setTimeout(()=>setActive(next),80)}root.addEventListener('click',e=>{const btn=e.target.closest('button.slider-button--next,button.splide__arrow--next,button.slider-button--prev,button.splide__arrow--prev');if(!btn||!root.contains(btn))return;e.preventDefault();e.stopPropagation();go(btn.classList.contains('slider-button--prev')||btn.classList.contains('splide__arrow--prev')?-1:1)},true);thumbs().forEach((t,i)=>t.addEventListener('click',()=>setTimeout(()=>{list.scrollTo({left:i*width(),behavior:'smooth'});setActive(i)},0)));list.addEventListener('scroll',()=>{clearTimeout(list._bloomArrowTimer);list._bloomArrowTimer=setTimeout(()=>setActive(index()),120)},{passive:true})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();})();

/* Bloom cosmetic-band mobile gallery arrow fallback retry v2 */
(()=>{const SECTION='#shopify-section-template--26281102868767__main';function attach(){const root=document.querySelector(SECTION);if(!root||root.dataset.bloomGalleryArrowFixRetryV2)return false;const list=root.querySelector('.product__media-list');if(!list)return false;root.dataset.bloomGalleryArrowFixRetryV2='1';function slides(){return [...list.querySelectorAll('.product__media-item')].filter(el=>el.getBoundingClientRect().width>50)}function thumbs(){return [...root.querySelectorAll('.thumbnail-list .thumbnail')]}function width(){return list.clientWidth||slides()[0]?.getBoundingClientRect().width||360}function index(){const w=width();return Math.max(0,Math.min(slides().length-1,Math.round(list.scrollLeft/w)))}function setActive(i){slides().forEach((s,n)=>s.classList.toggle('is-active',n===i));thumbs().forEach((t,n)=>t.setAttribute('aria-current',n===i?'true':'false'))}function go(delta){const items=slides();if(!items.length)return;const next=Math.max(0,Math.min(items.length-1,index()+delta));list.scrollTo({left:next*width(),behavior:'smooth'});window.setTimeout(()=>setActive(next),120)}root.addEventListener('click',e=>{const btn=e.target.closest('button.slider-button--next,button.splide__arrow--next,button.slider-button--prev,button.splide__arrow--prev');if(!btn||!root.contains(btn))return;e.preventDefault();e.stopImmediatePropagation();go(btn.classList.contains('slider-button--prev')||btn.classList.contains('splide__arrow--prev')?-1:1)},true);thumbs().forEach((t,i)=>t.addEventListener('click',()=>window.setTimeout(()=>{list.scrollTo({left:i*width(),behavior:'smooth'});setActive(i)},0),true));list.addEventListener('scroll',()=>{clearTimeout(list._bloomArrowRetryTimer);list._bloomArrowRetryTimer=window.setTimeout(()=>setActive(index()),120)},{passive:true});return true}function boot(){if(attach())return;let tries=0;const timer=window.setInterval(()=>{tries+=1;if(attach()||tries>80)window.clearInterval(timer)},125);if(window.MutationObserver){const mo=new MutationObserver(()=>{if(attach())mo.disconnect()});mo.observe(document.documentElement,{childList:true,subtree:true});window.setTimeout(()=>mo.disconnect(),10000)}}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();window.addEventListener('load',boot,{once:true});})();

/* bloom-serum-thumb-scroll-sync-js-20260810: keep serum vertical thumbnails synced with main gallery scroll. */
(()=>{
  const SECTION='#shopify-section-template--26300106866975__main';
  function boot(){
    const root=document.querySelector(SECTION);
    if(!root || root.dataset.bloomSerumThumbSync20260810)return false;
    const main=root.querySelector('[id^="Slider-Gallery-"]');
    const thumbs=root.querySelector('[id^="Slider-Thumbnails-"]');
    if(!main||!thumbs)return false;
    root.dataset.bloomSerumThumbSync20260810='1';
    const thumbButtons=()=>Array.from(thumbs.querySelectorAll('button.thumbnail'));
    const slides=()=>Array.from(main.querySelectorAll('.product__media-item')).filter(el=>el.getBoundingClientRect().width>50);
    const getIndex=()=>{
      const w=main.clientWidth||slides()[0]?.getBoundingClientRect().width||1;
      return Math.max(0,Math.min(slides().length-1,Math.round(main.scrollLeft/w)));
    };
    const setActive=(i,scroll=true)=>{
      const btns=thumbButtons();
      btns.forEach((b,n)=>{
        if(n===i)b.setAttribute('aria-current','true');
        else b.removeAttribute('aria-current');
      });
      const target=btns[i]?.closest('.thumbnail-list__item')||btns[i];
      if(scroll&&target){
        const top=target.offsetTop;
        const bottom=top+target.offsetHeight;
        const viewTop=thumbs.scrollTop;
        const viewBottom=viewTop+thumbs.clientHeight;
        if(top<viewTop) thumbs.scrollTo({top:top,behavior:'smooth'});
        else if(bottom>viewBottom) thumbs.scrollTo({top:bottom-thumbs.clientHeight,behavior:'smooth'});
      }
    };
    let timer;
    main.addEventListener('scroll',()=>{
      clearTimeout(timer);
      timer=setTimeout(()=>setActive(getIndex(),true),80);
    },{passive:true});
    root.addEventListener('click',e=>{
      const btn=e.target.closest('button.slider-button--next,button.slider-button--prev,button.splide__arrow--next,button.splide__arrow--prev');
      if(!btn||!root.contains(btn))return;
      setTimeout(()=>setActive(getIndex(),true),180);
      setTimeout(()=>setActive(getIndex(),true),420);
    },true);
    thumbButtons().forEach((b,i)=>b.addEventListener('click',()=>setTimeout(()=>setActive(i,true),120),true));
    setActive(getIndex(),true);
    return true;
  }
  function start(){
    if(boot())return;
    let tries=0;
    const t=setInterval(()=>{tries++; if(boot()||tries>80)clearInterval(t);},125);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  window.addEventListener('load',start,{once:true});
})();

/* bloom-serum-native-thumb-sync-20260810: patch existing executed media-gallery bundle for serum thumbnail scroll sync. */
(function(){
  const SECTION='shopify-section-template--26300106866975__main';
  function initSerumThumbSync(root){
    if(!root || root.dataset.bloomSerumNativeThumbSync20260810)return false;
    const main=root.querySelector('[id^="Slider-Gallery-"]');
    const thumbs=root.querySelector('[id^="Slider-Thumbnails-"]');
    if(!main || !thumbs)return false;
    root.dataset.bloomSerumNativeThumbSync20260810='1';
    const buttons=()=>Array.from(thumbs.querySelectorAll('button.thumbnail'));
    const slides=()=>Array.from(main.querySelectorAll('.product__media-item')).filter(el=>el.getBoundingClientRect().width>50);
    const index=()=>{
      const list=slides();
      if(!list.length)return 0;
      let best=0, bestDelta=Infinity;
      const left=main.scrollLeft;
      list.forEach((slide,i)=>{
        const delta=Math.abs((slide.offsetLeft||0)-left);
        if(delta<bestDelta){bestDelta=delta;best=i;}
      });
      return Math.max(0,Math.min(buttons().length-1,best));
    };
    function sync(scroll){
      const i=index();
      const btns=buttons();
      btns.forEach((btn,n)=>n===i?btn.setAttribute('aria-current','true'):btn.removeAttribute('aria-current'));
      const target=btns[i]?.closest('.thumbnail-list__item')||btns[i];
      if(scroll&&target){
        const top=target.offsetTop;
        const bottom=top+target.offsetHeight;
        const viewTop=thumbs.scrollTop;
        const viewBottom=viewTop+thumbs.clientHeight;
        if(top<viewTop)thumbs.scrollTo({top:top,behavior:'smooth'});
        else if(bottom>viewBottom)thumbs.scrollTo({top:bottom-thumbs.clientHeight,behavior:'smooth'});
      }
    }
    let timer;
    main.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(()=>sync(true),60);},{passive:true});
    root.addEventListener('click',event=>{
      const trigger=event.target.closest('button.slider-button--next,button.slider-button--prev,.slider-button');
      if(!trigger || !root.contains(trigger))return;
      setTimeout(()=>sync(true),120);
      setTimeout(()=>sync(true),360);
    },true);
    buttons().forEach((btn,i)=>btn.addEventListener('click',()=>{setTimeout(()=>sync(true),100);},true));
    sync(true);
    return true;
  }
  function bootSerumThumbSync(){
    const root=document.getElementById(SECTION);
    if(initSerumThumbSync(root))return;
    let tries=0;
    const interval=setInterval(()=>{
      tries+=1;
      if(initSerumThumbSync(document.getElementById(SECTION))||tries>100)clearInterval(interval);
    },100);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootSerumThumbSync,{once:true}); else bootSerumThumbSync();
  window.addEventListener('load',bootSerumThumbSync,{once:true});
})();
